import React from 'react';
import { GRID_SIZES } from '../constants/gameConstants';

const GridSizeSelector = ({ currentWidth, currentHeight, onSizeChange }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '8px'
    }}>
      {GRID_SIZES.map((size, index) => {
        const isSelected = currentWidth === size.width && currentHeight === size.height;
        const displayText = size.width === size.height 
          ? `${size.width}x${size.height}` 
          : `${size.width}x${size.height}`;
        
        return (
          <button
            key={`${size.width}-${size.height}-${index}`}
            onClick={() => onSizeChange(size.width, size.height)}
            style={{
              padding: '8px 12px',
              backgroundColor: isSelected ? '#4CAF50' : '#f0f0f0',
              color: isSelected ? 'white' : 'black',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              minWidth: '60px',
              boxShadow: isSelected ? '0 2px 4px rgba(0,0,0,0.2)' : 'none'
            }}
          >
            {displayText}
          </button>
        );
      })}
    </div>
  );
};

export default GridSizeSelector; 